import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

// Moved from client-dashboard (ID-13350) and rewired to useApi(). The legacy version raised the
// fullscreen loader inside the hook via useDataFetchIndicator; per loading-conventions the hook now
// stays silent and exposes `fetching`, and the ClientAccountList root raises the blocking loader
// around this fetch.
export default function useFetchClientAccountBalanceRange() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [balanceRange, setBalanceRange] = useState<[number, number]>([0, 0]);

  async function fetchClientAccountBalanceRange() {
    try {
      setFetching(true);
      const res = await api.fetchClientAccountBalanceRange();

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      const range: [number, number] = [res.MinBalance, res.MaxBalance];
      setBalanceRange(range);

      return {
        ...res,
        range,
      };
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return {
    balanceRange,
    fetching,
    fetchClientAccountBalanceRange,
  };
}
